import { render } from "./NewTransferModal.vue?vue&type=template&id=61b1b580"
import script from "./NewTransferModal.vue?vue&type=script&lang=js"
export * from "./NewTransferModal.vue?vue&type=script&lang=js"

import "./NewTransferModal.vue?vue&type=style&index=0&id=61b1b580&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__